<template>
    <b-form-group>
        <b-img 
            v-if="question.question_type=='4QV'" 
            :src="decodedImage" 
            ref="image"
            fluid
        ></b-img>
        <b-form-radio-group
            id="btn-radios"
            v-model="selected"
            button-variant="outline-primary"
            size="lg"
            name="radio-btn-outline"
            buttons
        >
            <template v-for="answer in question.answers">
                <b-container v-bind:key="answer.id" fluid="md" class="response-container col-xs-12 col-md-6 col-xl-3">
                    <radio-button :value="answer.id" :text="answer.answer_value" class="radioButton"></radio-button>
                </b-container>
            </template>
        </b-form-radio-group>
    </b-form-group>
</template>

<script>
import RadioButton from '../RadioButton.vue'
export default {
  watch: {
    selected: function() {
        this.$emit('update-selected', this.selected)
    }
  },
  data () {
    return {
        selected: null,
    }
  },
  computed: {
    decodedImage () {
        return `data:image/jpeg;base64, ${this.encodedFile}`
    }
  },
  components: { RadioButton },
  props: {
      question: Object,
      encodedFile: String,
  }
}
</script>

<style scoped>
#btn-radios {
    display: flex;
    justify-content: space-around;
    flex-wrap: wrap;
    margin: 1.5rem auto 0;
    width: 100%;
}
.radioButton {
    display: grid;
    align-items: center;
    width:100%;
    font-size: 0.9em;
    margin: 0.7rem;
    min-height: 11rem;
}
.response-container {
    display: grid;
}
.button-group {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    margin-top: 2rem
}
</style>